import {
  CLEANUP_DISCOVER_PROVINCE_DETAILS,
  GET_DISCOVERY_PROVINCES,
  GET_DISCOVERY_PROVINCES_FAILED,
  GET_DISCOVERY_PROVINCES_SUCCESS,
  GET_DISCOVERY_PROVINCE_DETAILS,
  GET_DISCOVERY_PROVINCE_DETAILS_FAILED,
  GET_DISCOVERY_PROVINCE_DETAILS_SUCCESS,
  GET_PROVINCES_NAME,
  GET_PROVINCES_NAME_SUCCESS,
  GET_PROVINCES_NAME_FAILED,
  CLEANUP_PROVINCES_NAME,
  CLEANUP_DISCOVERY_PROVINCES,
} from './actionTypes';

// actionGetDiscoveryProvinces
export const actionGetDiscoveryProvinces = (payload) => ({
  payload,
  type: GET_DISCOVERY_PROVINCES,
});

export const actionGetDiscoveryProvincesSuccess = (payload) => ({
  payload,
  type: GET_DISCOVERY_PROVINCES_SUCCESS,
});

export const actionGetDiscoveryProvincesFailed = () => ({
  type: GET_DISCOVERY_PROVINCES_FAILED,
});

export const actionCleanupDiscoveryProvinces = () => ({
  type: CLEANUP_DISCOVERY_PROVINCES,
});

// actionGetDiscoveryProvincesDetails
export const actionGetDiscoveryProvinceDetails = (payload) => ({
  payload,
  type: GET_DISCOVERY_PROVINCE_DETAILS,
});

export const actionGetDiscoveryProvinceDetailsSuccess = (payload) => ({
  payload,
  type: GET_DISCOVERY_PROVINCE_DETAILS_SUCCESS,
});

export const actionGetDiscoveryProvinceDetailsFailed = () => ({
  type: GET_DISCOVERY_PROVINCE_DETAILS_FAILED,
});

export const actionCleanupDiscoverProvinceDetails = () => ({
  type: CLEANUP_DISCOVER_PROVINCE_DETAILS,
});

// actionGetProvincesName
export const actionGetProvincesName = (payload) => ({
  payload,
  type: GET_PROVINCES_NAME,
});

export const actionGetProvincesNameSuccess = (payload) => ({
  payload,
  type: GET_PROVINCES_NAME_SUCCESS,
});

export const actionGetProvincesNameFailed = () => ({
  type: GET_PROVINCES_NAME_FAILED,
});

export const actionCleanupProvincesName = () => ({
  type: CLEANUP_PROVINCES_NAME,
});
